import React, { useState, useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { IoIosCloseCircle } from "react-icons/io";
import { toast } from 'react-toastify';
import SummaryApi from '../common';

const NotAnsweredModal = ({
  isOpen,
  onClose,
  student,
  isUpdate,
  isUpload,
  memberType,
  loadingSubmit,
  setLoadingSubmit,
  enrollmentCode,
  setEnrollmentCode,
  fetchStudents,
  reasons,
  districts,
}) => {
  const [formData, setFormData] = useState({
    student_name: '',
    gender: 'Male',
    father_name: '',
    mobile_number1: '',
    mobile_number2: '',
    email: '',
    aadhar_number: '',
    state: '',
    district: '',
    city: '',
    address: '',
    pincode: '',
    course: '',
    clg_name: '',
    program_type: '',
    ug_pg_course: '',
    call_back_reason: '',
    call_duration: '00:00:00.000000',
    other_reasons: '',
    is_interested: '',
    call_status: '',
    remarks: '',
    prev_call_back_reason: '',
    hours: '00',
    minutes: '00',
    seconds: '00',
    inter_percentage: '',
    is_jee: '',
    is_jee2: '',
  });

  const [selectedCourses, setSelectedCourses] = useState([]);
  const [dropdownValue, setDropdownValue] = useState('');

  const ugCourses = ['CSE', 'CSE(AI & ML)', 'CSE(AI & DS)', 'AERONAUTICAL ENGINERRING', 'ECE'];
  const pgCourses = [];
  const courses = formData.program_type === 'UG' ? ugCourses : formData.program_type === 'PG' ? pgCourses : [];

  const headers = {
    'Authorization': 'Bearer sandeep_university_916',
    'Content-Type': 'application/json',
  };

  useEffect(() => {
    if (!isOpen || !student) {
      // Reset when modal closes or no student
      setFormData({
        student_name: '',
        gender: 'Male',
        father_name: '',
        mobile_number1: '',
        mobile_number2: '',
        email: '',
        aadhar_number: '',
        state: '',
        district: '',
        city: '',
        address: '',
        pincode: '',
        course: '',
        clg_name: '',
        remarks: '',
        call_status: '',
        call_duration: '00:00:00.000000',
        program_type: '',
        ug_pg_course: '',
        is_interested: '',
        hours: '00',
        minutes: '00',
        seconds: '00',
        inter_percentage: '',
      });
      setSelectedCourses([]);
      setDropdownValue('');
      return;
    }

    const sanitizeStudentData = (data) => {
      const sanitizedData = { ...data };
      Object.keys(sanitizedData).forEach((key) => {
        if (sanitizedData[key] === "N/A") {
          sanitizedData[key] = "";
        }
      });
      return sanitizedData;
    };

    const payload = {
      employee_id: student?.employee_id,
      student_name: student?.student_name,
      gender: student?.gender,
      father_name: student?.father_name,
      mobile_number1: student?.mobile_number1,
      mobile_number2: student?.mobile_number2 || '',
      email: student?.email || '',
      aadhar_number: student?.aadhar_number || '',
      state: student?.state,
      district: student?.district,
      city: student?.city,
      address: student?.address,
      pincode: student?.pincode || '',
      course: student?.course,
      clg_name: student?.clg_name,
      inter_percentage: student?.inter_percentage,
      program_type: student?.program_type,
      ug_pg_course: student?.ug_pg_course,
      call_status: student?.call_status || '',
      call_duration: student?.call_duration || '00:00:00.000000',
      remarks: student?.remarks || '',
      is_interested: reasons.includes(student?.is_interested) ? "Others" : student?.is_interested,
      other_reasons: student?.is_interested,
      call_back_reason: student?.call_back_reason,
      prev_call_back_reason: student?.call_back_reason,
      is_jee: student?.is_jee,
      is_jee2: student?.is_jee2,
    };

    const sanitizedStudent = sanitizeStudentData(payload);

    const [timePart] = sanitizedStudent.call_duration.split('.');
    const [hours, minutes, seconds] = timePart.split(':');

    setFormData({
      ...sanitizedStudent,
      hours: hours.padStart(2, '0'),
      minutes: minutes.padStart(2, '0'),
      seconds: seconds.padStart(2, '0'),
    });

    if (isUpdate || !isUpload) {
      const coursesArray = sanitizedStudent.ug_pg_course
        ? sanitizedStudent.ug_pg_course.split(',').map(course => course.trim())
        : [];
      setSelectedCourses(coursesArray);
    }
  }, [student, isOpen, isUpdate, isUpload, reasons]);

  const validateForm = () => {
    const { call_status, is_interested, call_back_reason, other_reasons } = formData;
    if (call_status === 'Contacted') {
      if (!['Not Interested', 'Interested', 'Most Interested', 'Call Back', 'Others'].includes(is_interested)) {
        toast.warning('Please select an option: Not Interested, Interested, Most Interested, Call Back, or Others.');
        return false;
      }
      if (is_interested === 'Call Back' && !call_back_reason) {
        toast.warning('Please select a Call Back reason.');
        return false;
      }
      if (is_interested === 'Others' && !other_reasons) {
        toast.warning('Please select an Other reason.');
        return false;
      }
    }
    return true;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'call_status' && (value === 'Not Answered' || value === '')) {
      setFormData((prev) => ({
        ...prev,
        is_interested: '',
        [name]: value,
      }));
    }
    else if (name === 'is_interested') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(value !== 'Call Back' && { call_back_reason: '' }),
        ...(value !== 'Others' && { other_reasons: '' }),
      }));
    }
    else if (name === 'program_type' && (value === 'PG' || value === '')) {
      setSelectedCourses([]);
      setDropdownValue('');
      setFormData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
    else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };

  const handleSelectChange = (e) => {
    const selectedCourse = e.target.value;
    if (selectedCourse && !selectedCourses.includes(selectedCourse)) {
      setSelectedCourses((prev) => [...prev, selectedCourse]);
    }
    setDropdownValue('');
  };

  const handleRemoveTag = (course) => {
    setSelectedCourses((prev) => prev.filter(c => c !== course));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingSubmit(true);

    if (!validateForm()) {
      setLoadingSubmit(false);
      return;
    }

    try {
      const encodedEmployeeId = sessionStorage.getItem('H7Z4L9VD2XK5JW8QRYT6');
      if (!encodedEmployeeId) {
        throw new Error('Employee ID not found in session storage');
      }
      const decodedEmployeeId = atob(encodedEmployeeId);

      const apiEndpoint = isUpdate ? SummaryApi.updateStudent.url : SummaryApi.uploadStudent.url;
      const method = isUpdate ? SummaryApi.updateStudent.method : SummaryApi.uploadStudent.method;

      const today = new Date();
      const formattedFollowUpDate = today.toISOString();

      const payloadData = {
        employee_student_id: formData.employee_student_id,
        student_name: formData.student_name,
        last_name: '',
        gender: formData.gender,
        father_name: formData.father_name,
        mobile_number1: formData.mobile_number1,
        mobile_number2: formData.mobile_number2 || '',
        email: formData.email || '',
        aadhar_number: formData.aadhar_number || '',
        state: formData.state,
        district: formData.district,
        city: formData.city,
        address: formData.address,
        pincode: formData.pincode || '',
        course: formData.course,
        clg_name: formData.clg_name,
        inter_percentage: formData.inter_percentage || '',
        program_type: formData.program_type,
        ug_pg_course: selectedCourses.join(', '),
        call_status: formData.call_status || '',
        call_duration: formData.call_duration || '00:00:00.000000',
        remarks: formData.remarks || '',
        is_interested: formData.is_interested === 'Others' ? formData.other_reasons : formData.is_interested,
        call_back_reason: formData.call_back_reason || '',
        is_jee: (formData.is_jee === "Jee Mains Results")
          ? "Jee Mains Results"
          : (["Interested", "Not Interested", "Most Interested"].includes(formData.is_interested))
            ? (formData.prev_call_back_reason === "Jee Mains Results"
              ? "Jee Mains Results"
              : "")
            : "",
        is_jee2: (formData.is_jee2 === "Jee Mains-2 Results")
          ? "Jee Mains-2 Results"
          : (["Interested", "Not Interested", "Most Interested"].includes(formData.is_interested))
            ? (formData.prev_call_back_reason === "Jee Mains-2 Results"
              ? "Jee Mains-2 Results"
              : "")
            : "",
      };

      const payload = isUpdate
        ? {
          ...payloadData,
          student_id: student.student_id,
          employee_id: decodedEmployeeId,
          follow_up_date: formattedFollowUpDate,
        }
        : {
          ...payloadData,
          employee_id: decodedEmployeeId,
        };

      const response = await fetch(apiEndpoint, {
        method: method,
        headers: headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();

      if (result.status) {
        toast.success(isUpdate ? 'Student updated successfully!' : 'Student added successfully!');
        if (!isUpdate) {
          setEnrollmentCode(result.ENR_CODE);
        }
        onClose();
        fetchStudents();
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const handleChangeCallDuration = (e) => {
    // This function seems unused now – keeping it as in original
    const value = Math.max(0, Math.min(e.target.value, 30));
    setFormData({
      ...formData,
      call_duration: value,
    });
  };

  return (
    <>
      <div className="sticky top-0 z-10 bg-white px-8 py-4">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-semibold">
            {isUpdate ? 'Edit Student' : isUpload ? 'Add Student' : 'Student Details'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 transition-colors"
          >
            <AiOutlineClose size={22} />
          </button>
          {/* <div>
            {
              !(isUpdate || isUpload) && (
                <>
                  <button
                    className={`px-4 py-2 rounded-lg text-white mr-4 ${formData.is_interested !== "Most Interested" ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'}`}
                    disabled={formData.is_interested !== "Most Interested"}
                  >
                    Send Mail
                  </button>
                  <button
                    className={`px-4 py-2 rounded-lg text-white mr-4 ${formData.is_interested !== "Most Interested" ? 'bg-gray-300 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'}`}
                    disabled={formData.is_interested !== "Most Interested"}
                  >
                    Send WhatsApp Message
                  </button>
                </>
              )
            }
            <button onClick={onClose}>
              <AiOutlineClose className="w-6 h-6 text-gray-600 hover:text-gray-800 transition duration-200" />
            </button>
          </div> */}
        </div>
      </div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 sm:p-8">
        <div className="flex flex-col">
          <label htmlFor="student_name" className="flex items-center">Student Name<span className='ml-1 text-red-600'>*</span></label>
          <input
            type="text"
            id="student_name"
            name="student_name"
            value={formData.student_name}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
            required
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="gender" className="flex items-center">Gender</label>
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="father_name" className="flex items-center">Father Name</label>
          <input
            type="text"
            id="father_name"
            name="father_name"
            value={formData.father_name}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="mobile_number1" className="flex items-center">Mobile Number 1<span className='ml-1 text-red-600'>*</span></label>
          <input
            type="tel"
            id="mobile_number1"
            name="mobile_number1"
            value={formData.mobile_number1}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 10) {
                setFormData((prev) => ({ ...prev, mobile_number1: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={true}
            required
            pattern="\d{10}"
            title="Mobile number must be exactly 10 digits."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="mobile_number2" className="flex items-center">Mobile Number 2:</label>
          <input
            type="tel"
            id="mobile_number2"
            name="mobile_number2"
            value={formData.mobile_number2}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 10) {
                setFormData((prev) => ({ ...prev, mobile_number2: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
            pattern="\d{10}"
            title="Mobile number must be exactly 10 digits."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="email" className="flex items-center">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="aadhar_number" className="flex items-center">Aadhar Number:</label>
          <input
            type="text"
            id="aadhar_number"
            name="aadhar_number"
            value={formData.aadhar_number}
            onChange={(e) => {
              const rawValue = e.target.value.replace(/-/g, '');
              const formattedValue = rawValue
                .replace(/\D/g, '')
                .replace(/(\d{4})(?=\d)/g, '$1-');
              if (formattedValue.length <= 14) {
                setFormData((prev) => ({ ...prev, aadhar_number: formattedValue }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
            pattern="(\d{4}-\d{4}-\d{4})"
            title="Aadhar number must be in the format 1234-5678-9012."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="state" className="flex items-center">State</label>
          <input
            type="text"
            id="state"
            name="state"
            value={formData.state}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="district" className="flex items-center">District</label>
          <select
            id="district"
            name="district"
            value={formData.district}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          >
            <option value="">Select District</option>
            {districts.map((district, index) => (
              <option key={index} value={district}>{district}</option>
            ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="city" className="flex items-center">City:</label>
          <input
            type="text"
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="address" className="flex items-center">Address:</label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="pincode" className="flex items-center">Pincode:</label>
          <input
            type="text"
            id="pincode"
            name="pincode"
            value={formData.pincode}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 6) {
                setFormData((prev) => ({ ...prev, pincode: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
            pattern="\d{6}"
            title="Pincode must be exactly 6 digits."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="course" className="flex items-center">Course</label>
          <input
            type="text"
            id="course"
            name="course"
            value={formData.course}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="clg_name" className="flex items-center">College</label>
          <input
            type="text"
            id="clg_name"
            name="clg_name"
            value={formData.clg_name}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="inter_percentage" className="flex items-center">Intermediate Percentage/CGPA</label>
          <input
            type="text"
            id="inter_percentage"
            name="inter_percentage"
            value={formData.inter_percentage}
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^(\d+(\.\d*)?|\.\d+)?$/;
              if (regex.test(value) || value === '') {
                setFormData((prev) => ({ ...prev, inter_percentage: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="program_type" className="flex items-center">Program Type</label>
          <select
            id="program_type"
            name="program_type"
            value={formData.program_type}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          >
            <option value="">Select Program Type</option>
            <option value="UG">UG</option>
            <option value="PG">PG</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="ug_pg_course" className="flex items-center">UG/PG Course</label>
          <select
            id="ug_pg_course"
            name="ug_pg_course"
            value={dropdownValue}
            onChange={handleSelectChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course} value={course}>{course}</option>
            ))}
          </select>

          <div className="flex flex-wrap gap-2 mt-2">
            {selectedCourses.map((course) => (
              <div key={course} className="flex items-center bg-blue-100 rounded-full px-3 py-1">
                <span>{course}</span>
                <button
                  type="button"
                  className="ml-2 text-red-500"
                  disabled={!(isUpdate || isUpload)}
                  onClick={() => handleRemoveTag(course)}
                >
                  <IoIosCloseCircle className='text-blue-800 w-5 h-5' />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col">
          <label htmlFor="call_duration" className="flex items-center text-lg font-semibold text-gray-700 mb-2">
            Call Duration
          </label>
          <div className="flex flex-row space-x-2">
            <div className="relative">
              <input
                type="text"
                id="hours"
                name="hours"
                value={formData.hours.padStart(2, '0')}
                className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                disabled
              />
              <span className="absolute right-2 top-2 text-gray-500 font-bold">h</span>
            </div>
            <div className="flex items-center text-gray-500 font-bold">:</div>
            <div className="relative">
              <input
                type="text"
                id="minutes"
                name="minutes"
                value={formData.minutes.padStart(2, '0')}
                className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                disabled
              />
              <span className="absolute right-2 top-2 text-gray-500 font-bold">m</span>
            </div>
            <div className="flex items-center text-gray-500 font-bold">:</div>
            <div className="relative">
              <input
                type="text"
                id="seconds"
                name="seconds"
                value={formData.seconds.padStart(2, '0')}
                className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                disabled
              />
              <span className="absolute right-2 top-2 text-gray-500 font-bold">s</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <label htmlFor="call_status" className="flex items-center">Call Status<span className='ml-1 text-red-600'>*</span></label>
          <select
            id="call_status"
            name="call_status"
            value={formData.call_status}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
            required
          >
            <option value="">Select Status</option>
            <option value="Contacted">Contacted</option>
            <option value="Not Answered">Not Answered</option>
          </select>
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <label htmlFor="remarks" className="flex items-center">Remarks:</label>
          <textarea
            id="remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'}`}
            disabled={!(isUpdate || isUpload)}
            rows={2}
          />
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <div className="flex">
            <label className="flex items-center mr-4">
              <input
                type="radio"
                name="is_interested"
                value="Not Interested"
                checked={formData.is_interested === 'Not Interested'}
                onChange={handleChange}
                className="mr-2"
                disabled={formData.call_status === 'Not Answered' || formData.call_status === '' || !(isUpdate || isUpload)}
              />
              Not Interested
            </label>
            <label className="flex items-center mr-4">
              <input
                type="radio"
                name="is_interested"
                value="Interested"
                checked={formData.is_interested === 'Interested'}
                onChange={handleChange}
                className="mr-2"
                disabled={formData.call_status === 'Not Answered' || formData.call_status === '' || !(isUpdate || isUpload)}
              />
              Interested
            </label>
            <label className="flex items-center mr-4">
              <input
                type="radio"
                name="is_interested"
                value="Most Interested"
                checked={formData.is_interested === 'Most Interested'}
                onChange={handleChange}
                className="mr-2"
                disabled={formData.call_status === 'Not Answered' || formData.call_status === '' || !(isUpdate || isUpload)}
              />
              Most Interested
            </label>
            <label className="flex items-center mr-4">
              <input
                type="radio"
                name="is_interested"
                value="Call Back"
                checked={formData.is_interested === 'Call Back'}
                onChange={handleChange}
                className="mr-2"
                disabled={formData.call_status === 'Not Answered' || formData.call_status === '' || !(isUpdate || isUpload)}
              />
              Call Back
            </label>
            <label className="flex items-center mr-4">
              <input
                type="radio"
                name="is_interested"
                value="Others"
                checked={formData.is_interested === 'Others'}
                onChange={handleChange}
                className="mr-2"
                disabled={formData.call_status === 'Not Answered' || formData.call_status === '' || !(isUpdate || isUpload)}
              />
              Others
            </label>
          </div>

          <div className="flex items-center mt-4">
            {formData.is_interested === 'Call Back' && (
              <div className="mt-2 flex items-center justify-center">
                <label htmlFor="call_back_reason" className="block mb-2">Call Back Reason<span className='ml-1 text-red-600'>*</span>:</label>
                <select
                  id="call_back_reason"
                  name="call_back_reason"
                  value={formData.call_back_reason || ''}
                  onChange={handleChange}
                  className="p-2 border ml-4 border-gray-300 rounded"
                  required={formData.is_interested === 'Call Back'}
                >
                  <option value="">Select Reason</option>
                  <option value="IPE Exams">IPE Exams</option>
                  <option value="Jee Mains Results">JEE Mains Results</option>
                  <option value="Jee Mains-2 Results">JEE Mains-2 Results</option>
                  <option value="Eamcet Results">EAMCET Results</option>
                  <option value="IPE Results">IPE Results</option>
                  <option value="Supply Exams">Supply Exams</option>
                  <option value="Supply Results">Supply Results</option>
                  <option value="EOD">EOD</option>
                </select>
              </div>
            )}

            {formData.is_interested === 'Others' && (
              <div className="mt-2 flex items-center justify-center">
                <label htmlFor="other_reasons" className="block mb-2">Other Reason<span className='ml-1 text-red-600'>*</span>:</label>
                <select
                  id="other_reasons"
                  name="other_reasons"
                  value={formData.other_reasons || ''}
                  onChange={handleChange}
                  className="p-2 border ml-4 border-gray-300 rounded"
                  required={formData.is_interested === 'Others'}
                >
                  <option value="">Select Reason</option>
                  <option value="Wrong Number">Wrong Number</option>
                  <option value="Not Reachable">Not Reachable</option>
                  <option value="Number Not Working">Number Not Working</option>
                  <option value="Call Declined">Call Declined</option>
                  <option value="Busy">Busy</option>
                  <option value="Switched Off">Switched Off</option>
                  <option value="Incoming Calls Stopped">Incoming Calls Stopped</option>
                </select>
              </div>
            )}
          </div>
        </div>

        {(isUpdate || isUpload) && (
          <div className="flex flex-col col-span-1 sm:col-span-2">
            <button
              type="submit"
              className={`bg-blue-600 text-white px-4 py-2 rounded ${!(isUpdate || isUpload) && 'cursor-not-allowed'} ${loadingSubmit && 'cursor-not-allowed'}`}
              disabled={!(isUpdate || isUpload) || loadingSubmit}
            >
              {loadingSubmit ? 'Submitting...' : (isUpdate ? 'Update Student' : 'Add Student')}
            </button>
          </div>
        )}
      </form>
    </>
  );
};

export default NotAnsweredModal;